import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import Layout from "../components/layout/LayoutV2.vue";
import store from "../store/index"
import Success from "@/views/salesManagement/proposal/Success.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/signin',
        name: 'login',
        component: LoginView
    },
    {
        path: '/success',
        name: "Success",
        component:  Success,
    },
    {
        path: '/OTP',
        name: 'OTP',
        props: (route) => ({ formData: route.query }),
        component: () => import(/* webpackChunkName: "user-otp" */ '../views/otp.vue')
    },
    {
        path: '/ResetView',
        name: 'ResetView',
        props: (route) => ({ formData: route.query }),
        component: () => import(/* webpackChunkName: "user-otp" */ '../views/ResetView.vue')
    },
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '/user-dashboard',
                name: 'user-dashboard',
                component: () => import(/* webpackChunkName: "user-dashboard" */ '../views/tickets/TicketListView.vue')
            },

            {
                path: '/ImportStore/:mainCustomerID',
                name: 'ImportStore',
                component: () => import(/* webpackChunkName: "ImportStore" */ '../views/customer/Stores/ImportStore')
            },
            {
                path: '/StoreInfo/:mainCustomerID',
                name: 'StoreInfo',
                component: () => import(/* webpackChunkName: "StoreInfo" */ '../views/customer/Stores/StoreInfo')
            },

            {
                path: '/Pendinginstallations',
                name: 'Pendinginstallations',
                component: () => import(/* webpackChunkName: "create-ticket" */ '../views/Admin/Pendinginstallations')
            },
            {
                path: '/RequestFunds',
                name: 'RequestFunds',
                component: () => import(/* webpackChunkName: "create-ticket" */ '../views/users/RequestFunds')
            },
            {
                path: '/create-ticket',
                name: 'create-ticket',
                component: () => import(/* webpackChunkName: "create-ticket" */ '../views/tickets/view/AddTicketView.vue')
            },


            {
                path:'/online-checker',
                name: 'online-checker',
                component: () => import(/* webpackChunkName: "online-checker" */ '../views/tickets/view/onlineChecker.vue')

            },

            {
                path: '/ticket/edit/:ticketId',
                name: 'edit-ticket',
                component: () => import(/* webpackChunkName: "edit-ticket" */ '../views/tickets/view/EditTicketView')
            },

            {
                path: '/PendingEvents',
                name: 'PendingEvents',
                component: () => import(/* webpackChunkName: "search-ticket" */ '../views/tickets/view/PendingEvents')
            },
            {
                path: '/FollowUp',
                name: 'FollowUp',
                component: () => import(/* webpackChunkName: "FollowUp" */ '../views/tickets/view/FollowUp')
            },
            {
                path: '/PendingStock',
                name: 'PendingStock',
                component: () => import(/* webpackChunkName: "search-ticket" */ '../views/tickets/view/ReceivedStock.vue')
            },
            {
                path: '/JobCardManagement',
                name: 'JobCardManagement',
                component: () => import(/* webpackChunkName: "JobCardManagement" */ '../views/tickets/view/JobCardManagement')
            },
            {
                path: '/Milestones',
                name: 'MilestonesPage',
                component: () =>
                    import(/* webpackChunkName: "MilestonesPage" */ '../views/tickets/view/MilestonesPage')
            },
            {
                path: '/escalate-multiple',
                name: 'escalate-multiple',
                component: () => import(/* webpackChunkName: "escalate-multiple" */ '../views/tickets/view/EscalateMultipleView.vue')
            },
            {
                path: '/Disputes',
                name: 'DisputesPage',
                component: () =>
                    import(/* webpackChunkName: "MilestonesPage" */ '../views/tickets/view/DisputesPage')
            },
            {
                path: '/Linking',
                name: 'LinkingPage',
                component: () =>
                    import(/* webpackChunkName: "LinkingPage" */ '../views/tickets/view/LinkingPage')
            },
            {
                path: '/AvailableStock',
                name: 'AvailableStock',
                component: () => import(/* webpackChunkName: "AvailableStock" */ '../views/tickets/view/AvailableStock')
            },
            {
                path: '/request-details/:id',
                name: 'RequestDetails',
                component: () => import(/* webpackChunkName: "RequestDetails" */ '../views/tickets/view/RequestDetails'),
                props: true
            },
            {
                path: '/ticket/search',
                name: 'search-ticket',
                component: () => import(/* webpackChunkName: "search-ticket" */ '../views/tickets/view/TicketSearch')
            },
            {
                path: '/customer-tickets',
                name: 'customer-tickets',
                component: () => import(/* webpackChunkName: "customer-tickets" */ '../views/tickets/CustomerTicketList')
            },
            {
                path: '/ViewJobCard',
                name: 'viewJobCard',
                component: () => import(/* webpackChunkName: "ViewJobCard" */ '../views/tickets/view/ViewJobCard.vue')
            },
            {
                path: '/create-job-card',
                name: 'create-job-card',
                component: () => import(/* webpackChunkName: "create-job-card" */ '../views/tickets/view/CreateJobCard')
            },
            {
                path: '/ticket/:ticketId',
                props: true,
                name: 'view-ticket',
                component: () => import(/* webpackChunkName: "view-ticket" */ '../views/tickets/view/TicketDetailsView')
            },
            {
                path: '/tickets/:ticketId',
                props: true,
                name: 'view-ticket',
                component: () => import(/* webpackChunkName: "view-ticket" */ '../views/tickets/view/TicketDetailsView')
            },
            {
                path: '/RequestLeaveEarly/',
                name: 'RequestLeaveEarly',
                component: () => import(/* webpackChunkName: "view-ticket" */ '../components/tickets/view/RequestLeaveEarly.vue')
            },
            {
                path: 'ticket/:ticket/task',
                props: true,
                name: 'add-ticket-task',
                component: () => import(/*webpackChunkName: "add-task"*/'../views/tickets/tasks/TicketTaskView')
            },
            {
                path: 'ticket/:ticket/task/:task',
                props: true,
                name: 'edit-ticket-task',
                component: () => import(/*webpackChunkName: "edit-task"*/'../views/tickets/tasks/TicketTaskView')
            },
            {
                path: '/customer-list',
                name: 'customer-list',
                component: () => import(/* webpackChunkName: "customer-list" */ '../views/customer/CustomerList')
            },
            {
                path: '/view-ads',
                name: 'view-ads',
                component: () => import(/* webpackChunkName: "customer-list" */ '../views/customer/ViewAds')
            },
            {
                path: 'view-leads',
                name: 'view-leads',
                component: () => import(/* webpackChunkName: "customer-list" */ '../views/customer/ViewLeads')
            },
            {
                path: '/add-store/:mainCustomerID',
                name: 'add-store',
                component: () => import(/* webpackChunkName: "add-store" */ '../views/customer/Stores/CreateStore')
            },
            {
                path: '/StoreData/:mainCustomerID',
                name: 'StoreData',
                component: () => import(/* webpackChunkName: "StoreData" */ '../views/customer/Stores/StoreData')
            },
            {
                path: '/libratas',
                name: 'libratas',
                component: () => import(/* webpackChunkName: "libratas" */ '../views/customer/LibratasView')
            },
            {
                path: '/libratas-customer/:libratasCustomerId',
                name: 'libratas-customer-view',
                component: () => import(/* webpackChunkName: "libratas-customer-view" */ '../views/customer/LibratasCustomerView')
            },
            {
                path: '/importStoreData/:mainCustomerID',
                name: 'importStoreData',
                component: () => import(/* webpackChunkName: "StoreData" */ '../views/customer/Stores/importStoreData')
            },


            {
                path: '/selectStoreData/:mainCustomerID',
                name: 'selectStoreData',
                component: () => import(/* webpackChunkName: "StoreData" */ '../views/customer/Stores/selectStoreData')
            },
            {
                path: '/view-customer/:mainCustomerID',
                name: 'view-customer',
                component: () => import(/* webpackChunkName: "view-customer" */ '../views/customer/ViewCustomer')
            },
            {
                path: '/email-setup/:mainCustomerID',
                name: 'email-setup',
                component: () => import(/* webpackChunkName: "email-setup" */ '../views/customer/Stores/EmailSetupView')
            },
            {
                path: '/view-store/:storeID',
                name: 'view-store',
                component: () => import(/* webpackChunkName: "view-store" */ '../views/customer/Stores/ViewStoreTickets')
            },

            {
                path: '/select-location',
                name: 'select-location',
                component: () => import(/* webpackChunkName: "select-location" */ '../views/location/SelectLocationView')
            },
            {
                path: '/create-user',
                name: 'create-user',
                component: () => import(/* webpackChunkName: "create-user" */ '../views/users/CreateUpdateUserView')
            },
            {
                path: '/upload-training-video',
                name: 'upload-training-video',
                component: () => import(/* webpackChunkName: "create-user" */ '../views/users/UploadTrainingVideo.vue')
            },
            {
                path: '/leave',
                name: 'request-leave',
                component: () => import(/* webpackChunkName: "create-user" */ '../views/users/RequestLeave.vue')
            },
            {
                path: '/training-section',
                name: 'training-section',
                component: () => import(/* webpackChunkName: "create-user" */ '../views/users/TrainingSection.vue')
            },
            {
                path: '/view-leave',
                name: 'view-leave',
                component: () => import(/* webpackChunkName: "create-user" */ '../views/users/ViewLeaveRequests.vue')
            },
            {
                path: '/watch-video/:videoId',
                name: 'watch-video',
                component:()=> import( '../views/users/WatchVideo'),
            },
            {
                path: '/displinary',
                name: 'ViewDisplinary',
                component: () => import(/* webpackChunkName: "create-user" */ '../views/users/ViewDisplinary.vue')
            },
            {
                path: '/update-user/:id',
                name: 'update-user',
                component: () => import(/* webpackChunkName: "update-user" */ '../views/users/CreateUpdateUserView')
            },
            {
                path: '/view-user/:id',
                name: 'view-user',
                component: () => import(/* webpackChunkName: "view-user" */ '../views/users/ViewUserData')
            },
            {
                path: '/details/:id',
                name: 'details',
                component: () => import(/* webpackChunkName: "view-user" */ '../views/users/DetailsView.vue')
            },
            {
                path: '/users',
                name: 'users',
                component: () => import(/* webpackChunkName: "users" */ '../views/users/UsersView')
            },
            {
                path: '/BugReports',
                name: 'BugReports',
                component: () => import(/* webpackChunkName: "users" */ '../views/Reports/BugReports')
            },
            {
                path: '/Report',
                name: 'Report',
                component: () => import(/* webpackChunkName: "users" */ '../views/tickets/view/ProjectView.vue')
            },

            {
                path: '/calendar',
                name: 'calendar',
                component: () => import(/* webpackChunkName: "calendar" */ '../views/calendar/CalendarView')
            },
            {
                path: '/smart-invoice-product-list',
                name: 'smart-invoice-product-list',
                component: () => import(/* webpackChunkName: "smart-invoice-product-list" */ '../views/SmartInvoice/SIProductSelect')
            },
            {
                path: '/view-smart-invoice-signup',
                name: 'view-smart-invoice-signup',
                component: () => import(/* webpackChunkName: "view-smart-invoice-signup" */ '../views/SmartInvoice/ViewSmartInvoiceSignup')
            },
            {
                path: '/chrilan-smart-invoice',
                name: 'chrilan-smart-invoice',
                component: () => import(/* webpackChunkName: "chrilan-smart-invoice" */ '../views/SmartInvoice/Lyt-SI-Signup')
            },
            {
                path: '/lytsoft-smart-invoice',
                name: 'lytsoft-smart-invoice',
                component: () => import(/* webpackChunkName: "lytsoft-smart-invoice" */ '../views/SmartInvoice/LytSoft-Signup')
            },
            {
                path: '/view-lytsoft-smart-invoice',
                name: 'view-lytsoft-smart-invoice',
                component: () => import(/* webpackChunkName: "view-lytsoft-smart-invoice" */ '../views/SmartInvoice/ViewLytSoftSmartInvoiceSignup')
            },
            {
                path: '/performance',
                name: 'performance',
                component: () => import(/* webpackChunkName: "performance" */ '../views/tickets/UserPerformanceStats.vue')
            },
            {
                path: '/DetailsPage/:clientID',
                name: 'DetailsPage',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../components/DetailsPage.vue')
            },
            {
                path: '/App',
                name: 'appMarket',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/AppMarket.vue')
            },
            {
                path: '/Roles',
                name: 'roles',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/Admin/Roles.vue')
            },
            {
                path: '/ViewRoles',
                name: 'view-roles',
                component: () => import(/* webpackChunkName: "ViewRoles" */ '../views/Admin/ViewRoles.vue')
            },
            {
                path: '/ViewProjects',
                name: 'view-projects',
                component: () => import(/* webpackChunkName: "ViewProjects" */ '@/views/projects/ViewProjects.vue')
            },
            {
                path: '/ViewTeams',
                name: 'view-teams',
                component: () => import(/* webpackChunkName: "ViewProjects" */ '@/views/projects/ViewTeams.vue')
            },
            {
                path: '/ProjectDashboard',
                name: 'projectDashboard',
                component: () => import(/* webpackChunkName: "ProjectDashboard" */ '@/views/projects/users/DevelopmentDashboard.vue')
            },
            {
                path: '/Departments',
                name: 'department',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/Admin/DepartmentManagement.vue')
            },
            {
                path: '/ViewDepartments',
                name: 'view-departments',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/Admin/ViewDepartments.vue')
            },
            {
                path: '/fine',
                name: 'fine',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/Admin/FineView.vue')
            },
            {
                path: '/projects',
                name: 'projects',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/projects/createProject.vue')
            },
            {
                path: '/success',
                name: 'success',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../components/SuccessPage.vue')
            },
            // {
            //     path: '/Settings',
            //     name: 'settings',
            //     component: () => import(/* webpackChunkName: "Settings" */ '../views/settings/Settings.vue')
            // },
            {
                path: '/Settings',
                name: 'settings',
                component: () => import(/* webpackChunkName: "Settings" */ '../views/settings/Settings.vue')
            },
            {
                path: '/Subs',
                name: 'subs',
                component: () => import(/* webpackChunkName: "Subscription" */ '../views/customer/Subscription.vue')
            },
            {
                path: '/OfficeManagement',
                name: 'OfficeManagement',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/office/OfficeManagement.vue')
            },
            {
                path: '/officeDashboard',
                name: 'officeDashboard',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/office/officeDashboard.vue')
            },
            {
                path: '/OfficeProfile/:officeID',
                name: 'OfficeProfile',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '../views/office/OfficeProfile.vue')
            },
            {
                path: '/customerProfile',
                name: 'customerProfile',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/salesManagement/proposal/customerProfile.vue')
            },
            {
                path: '/SprintManagement',
                name: 'SprintManagement',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/TasksManagement/SprintManagement.vue')
            },
            {
                path: '/SprintTaskView/:taskID',
                name: 'SprintTaskView',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/TasksManagement/SprintTaskView.vue')
            },
            {
                path: '/salesPersonDashboard',
                name: 'salesPersonDashboard',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/salesManagement/salesPersonDashboard.vue')
            },
            {
                path: '/OverallSales',
                name: 'overallSales',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/salesManagement/OverallSalesData.vue')
            },
            {
                path: '/CreateQuote',
                name: 'CreateQuote',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/salesManagement/CreateQuote.vue')
            },
            {
                path: '/SearchedProducts',
                name: 'SearchedProducts',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/components/sales/SearchedProducts.vue')
            },
            {
                path: '/ViewQuote/:saleNum',
                name: 'ViewQuote',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/salesManagement/proposal/ViewQuote.vue')
            },
            {
                path: '/ConvertLead/:addId',
                name: 'ConvertLead',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/salesManagement/ConvertLead.vue')
            },



            {
                path: '/upload-feature-video',
                name: 'CreateUAT',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/uat/CreateUAT.vue')
            },
            {
                path: '/watch-uat-video/:Id',
                name: 'PerformUAT',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/uat/PerformUAT.vue')
            },
            {
                path: '/ReviewUAT',
                name: 'ReviewUAT',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/uat/ReviewUAT.vue')
            },
            {
                path: '/uat/:uatID',
                name: 'UATDetails',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/uat/UATDetails.vue')
            },
            {
                path: '/uat-list',
                name: 'UATList',
                component: () => import(/* webpackChunkName: "DetailsPage" */ '@/views/uat/UATList.vue')
            },
            {
                path: '/leaveRequests',
                name: 'LeaveRequests',
                component: () => import(/* webpackChunkName: "LeaveRequests" */ '@/views/managerTasks/LeaveRequests.vue')
            },
            {
                path: '/clearance',
                name: 'Clearance',
                component: () => import(/* webpackChunkName: "Clearance" */ '@/views/managerTasks/ManagerClearance.vue')
            },
            {
                path: '/view-clearance',
                name: 'ViewClearance',
                component: () => import(/* webpackChunkName: "ViewClearance" */ '@/views/hr/ViewClearance.vue')
            },
            {
                path: '/TagStatistics',
                name: 'TagStatistics',
                component: () => import(/* webpackChunkName: "ViewClearance" */ '@/views/tickets/TagStatistics.vue')
            },
            {
                path: '/ConvertExcel',
                name: 'convertExcel',
                component: () => import(/* webpackChunkName: "ConvertExcel" */ '@/components/ConvertExcel.vue')
            },
            {
                path: '/DeathClearanceConfig',
                name: 'deathConfig',
                component: () => import(/* webpackChunkName: "DeathClearanceConfig" */ '@/views/hr/DeathClearanceConfig.vue')
            },
            {
                path: '/test',
                name: 'test',
                component: () => import(/* webpackChunkName: "Test" */ '@/components/Test.vue')
            },
            {
                path: '/NewProjectsDashboard',
                name: 'NewProjectsDashboard',
                component: () => import(/* webpackChunkName: "Test" */ '@/views/projects/New/NewProjectsDashboard.vue')
            },
            {
                path: '/SmartInvoiceStats',
                name: 'smartInvoiceStats',
                component: () => import(/* webpackChunkName: "SmartInvoiceStats" */ '@/views/SmartInvoice/SmartInvoiceStats.vue')
            },
            {
                path: '/SmartInvoiceSearch',
                name: 'smartInvoiceSearch',
                component: () => import(/* webpackChunkName: "SmartInvoiceStats" */ '@/views/SmartInvoice/SmartInvoiceSearch.vue')
            },
            {
                path: '/lytsi-branches',
                name: 'lytsi-branches',
                component: () => import(/* webpackChunkName: "LytSiBranches" */ '@/views/SmartInvoice/LytSiBranchesView.vue')
            },
            {
                path: '/subscriptions/product-billing-cycles',
                name: 'ProductBillingCycles',
                component: () => import('../views/subscriptions/ProductBillingCyclesView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Product Billing Cycles'
                }
            },
            {
                path: '/subscriptions/primary-products',
                name: 'PrimaryProducts',
                component: () => import('../views/subscriptions/PrimaryProductsView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Primary Products'
                }
            },
            {
                path: '/subscriptions/invoices',
                name: 'SubscriptionInvoices',
                component: () => import('../views/subscriptions/CombinedInvoicesView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Subscription Invoices'
                }
            },
            {
                path: '/subscriptions/invoice-customers',
                name: 'InvoiceCustomers',
                component: () => import('../views/subscriptions/InvoiceCustomersView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Unpaid Subscriptions'
                }
            },
            {
                path: '/subscriptions/update-invoice/:id',
                name: 'UpdateInvoice',
                component: () => import('../views/subscriptions/UpdateInvoiceView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Update Invoice'
                }
            },
            {
                path: '/subscriptions/invoice-history',
                name: 'InvoiceHistory',
                component: () => import('../views/subscriptions/InvoiceHistoryView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Invoice History'
                }
            },
            {
                path: '/customer-onboarding',
                name: 'customer-onboarding',
                component: () => import('../views/CustomerOnboarding/CustomerOnboardDashboard.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Customer Onboarding'
                }
            },
            {
                path: '/customer-signups/:customerId',
                name: 'customer-signups',
                component: () => import('../views/CustomerOnboarding/CustomerSignupList.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Customer Signups'
                }
            },
            {
                path: '/view-customer-signup/:signupId',
                name: 'view-customer-signup',
                component: () => import('../views/CustomerOnboarding/ViewCustomerSignup.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'View Signup'
                }
            },
            {
                path: '/subscriptions/product-addons',
                name: 'ProductAddons',
                component: () => import('../views/subscriptions/ProductAddonsView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Product Add-ons'
                }
            },
            {
                path: '/subscriptions/addons',
                name: 'Addons',
                component: () => import('../views/subscriptions/AddonsView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Addons Management'
                }
            },
            {
                path: '/subscriptions/stores/:storeId/addons',
                name: 'StoreAddons',
                component: () => import('../views/subscriptions/StoreAddonsView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Store Addons'
                }
            },
            {
                path: '/subscriptions/bill-calculator',
                name: 'SubscriptionBillCalculator',
                component: () => import('../views/subscriptions/SubscriptionBillCalculatorView.vue'),
                meta: {
                  requiresAuth: true,
                  title: 'Subscription Bill Calculator'
                }
            },
            {
                path: '/SalesMeetingForm',
                name: 'SalesMeetingForm',
                component: () => import(/* webpackChunkName: "Test" */ '@/views/salesManagement/SalesMeetingForm.vue')
            },
            {
                path: '/Development',
                name: 'Development',
                component: () => import(/* webpackChunkName: "Test" */ '@/views/projects/New/Development.vue')
              },
              {
                path: '/UAT',
                name: 'UAT',
                component: () => import(/* webpackChunkName: "Test" */ '@/views/projects/New/UAT.vue')
              },
            {
                path: '/sprint/:sprintId',
                name: 'SprintDetailView',
                component: () => import(/* webpackChunkName: "SprintDetail" */ '@/views/projects/New/SprintDetailView.vue'),
                props: (route) => ({
                    sprintId: route.params.sprintId,
                    project: route.query.project
                })
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: '',
    routes
})

// Silence NavigationDuplicated errors globally
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// Override push method to handle NavigationDuplicated errors
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
    return Promise.resolve()
  })
}

// Override replace method to handle NavigationDuplicated errors
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
    return Promise.resolve()
  })
}
router.beforeEach(async (to, from, next) => {
    if (!store.getters.isHydrated) {
        await new Promise((resolve) => {
            const interval = setInterval(() => {
                console.log(`is Hydrated`,store.getters.isHydrated)
                if (store.getters.isHydrated) {
                    clearInterval(interval);
                    resolve();
                }
            }, 50);  // Check every 50ms
        });
    }

    const publicRoutes = ['login', 'OTP', 'ResetView']; // Routes that don't require OTP verification
    let isAuthenticated = localStorage.getItem('setSessionID');
    let isOtpVerified = localStorage.getItem('otpVerified') === 'true' || store.getters.isOtpVerified;

    // Handle direct links with userInfo
    if (to.query.userInfo && isAuthenticated) {
        console.log("This is the otp of the user ", isAuthenticated);
        let userInfo = JSON.parse(window.atob(to.query.userInfo));
        return store.dispatch('userLogin', userInfo);
    }
    // Allow access to public routes
    else if (publicRoutes.includes(to.name)) {
        next();
    }
    // Check for authentication and OTP verification
    else {
        let res = await authenticator.isUserLoggedIn();

        if (!res) {
            // User is not logged in
            store.commit(`setAttemptedRoute`, to);
            next({name: 'login'});
        }
        else if (!isOtpVerified) {
            // User is logged in but hasn't verified OTP
            store.commit(`setAttemptedRoute`, to);
            next({name: 'login'});
        }
        else if (res && to.path === `/`) {
            // User is logged in and OTP verified but trying to access root
            next({ name: 'user-dashboard' });
        }
        else {
            // User is logged in and OTP verified
            next();
        }
    }
})
export default router
